import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Paper from 'material-ui/Paper'
import moment from 'moment'

import Form from './Form'

import { createMarkup } from '../../lib'
import images from '../../config/images'
import Background from './Background'

const Registration = props => (
  <div className="min-h-inherit w-100">
    <Background/>
    <div className="absolute min-h-inherit w-100 flex justify-center items-center white">
      {props.isFetchingConferenceDetails ? (
        'Fetching Details'
      ) : (
        <div className="mt4" style={{height: '75vh', width: '70vw'}}>
          <div style={{fontSize: 36}} className="tc">
            {props.conferenceDetails.name}
          </div>
          {props.conferenceDetails.start_date ? (
            <div>
              <div className="tc mt3">
                <FormattedMessage id="seminar.beginsIn"/>..
              </div>
              <div
                className="tc mt3"
                style={{fontSize: 30, letterSpacing: '10px'}}
              >
                {moment(props.conferenceDetails.start_date).format(
                  'h:mm a, dddd MMM D, YYYY'
                )}
              </div>
            </div>
          ) : (
            <div
              className="tc mt3"
              style={{fontSize: 30, letterSpacing: '10px'}}
            >
              Conference not scheduled
            </div>
          )}
          <div className="flex justify-center mt3">
            <Paper
              className="pa3"
              style={{width: '50vw', height: '50vh', overflow: 'auto'}}
            >
              {props.conferenceDetails.description ? (
                <div
                  dangerouslySetInnerHTML={createMarkup(
                    props.conferenceDetails.description
                  )}
                />
              ) : (
                <FormattedMessage id="seminarActions.noDescription"/>
              )}
            </Paper>
          </div>
          <Form
            id={props.id}
            registerEmail={props.registerEmail}
            isRequestingRegisteration={props.isRequestingRegisteration}
          />
        </div>
      )}
    </div>

    <div className="absolute w-100">
      <div className="flex justify-between items-center pa3">
        <Link
          to={'/'}
        >
          <img src={images.webinar_logo} alt="logo"/>
        </Link>
        <div style={{fontSize: 26, color: '#ffffff'}}>
          {props.conferenceDetails.owner_name}
        </div>
      </div>
    </div>
  </div>
)

export default Registration



// WEBPACK FOOTER //
// ./src/routes/Registration/Registration.js